import Head from 'next/head'
import React from 'react'
import styled from 'styled-components'
import { getPublicLayout } from '@public/components/PublicLayout'
import { Box } from 'components/Layout'
import { prepareGetStaticNavigationProps } from 'routes/utils/prepareGetStaticNavigationProps'

const DESCRIPTION =
  'We`re hosting events in cities across the U.S. to connect with new people, share what we do, and introduce our Bronze Tier offering. Use this form to register your interest and stay in the loop.'

const Iframe = styled('iframe')`
  width: 100%;
  height: inherit;
`

export const Events = () => (
  <>
    <Head>
      <title>The Expert Events</title>
      <meta name="description" content={DESCRIPTION} />
      <meta name="twitter:description" content={DESCRIPTION} />
      <meta property="og:description" content={DESCRIPTION} />
    </Head>
    <Box
      width="100%"
      height={{ MOBILE: 'calc(100vh - 300px)', TABLET: 'calc(100vh - 150px)' }}
    >
      <Iframe
        className="airtable-embed"
        src="https://airtable.com/embed/apph39I60EY7ZhK8P/pagberqT5l56I1swx/form"
        title="airtable form"
      />
    </Box>
  </>
)

export function getStaticProps() {
  return prepareGetStaticNavigationProps()
}

Events.getLayout = (page) =>
  getPublicLayout(page, {
    isFullWidth: true,
  })
